import { createContext, useContext } from 'react';
import { fg } from '@atlaskit/platform-feature-flags';
/**
 * This provides the data that will be used by Smart Links Flexible UI to populate it's
 * underlying elements.
 */
export var FlexibleCardContext = /*#__PURE__*/createContext(undefined);
export var useFlexibleCardContext = function useFlexibleCardContext() {
  return useContext(FlexibleCardContext);
};

/**
 * This provides the data that will be used by Smart Links Flexible UI to populate it's
 * underlying elements.
 * @deprecated Remove on cleanup of platform-linking-flexible-card-context
 */
export var FlexibleUiContext = /*#__PURE__*/createContext(undefined);
export var useFlexibleUiContext = function useFlexibleUiContext() {
  var _useFlexibleCardConte;
  return fg('platform-linking-flexible-card-context') ? // eslint-disable-next-line react-hooks/rules-of-hooks
  (_useFlexibleCardConte = useFlexibleCardContext()) === null || _useFlexibleCardConte === void 0 ? void 0 : _useFlexibleCardConte.data :
  // eslint-disable-next-line react-hooks/rules-of-hooks
  useContext(FlexibleUiContext);
};

/**
 * This provides the ui options that will be used by Smart Links Flexible UI
 * to render its underlying elements.
 * @deprecated Remove on cleanup of platform-linking-flexible-card-context
 */
export var FlexibleUiOptionContext = /*#__PURE__*/createContext(undefined);
export var useFlexibleUiOptionContext = function useFlexibleUiOptionContext() {
  var _useFlexibleCardConte2;
  return fg('platform-linking-flexible-card-context') ? // eslint-disable-next-line react-hooks/rules-of-hooks
  (_useFlexibleCardConte2 = useFlexibleCardContext()) === null || _useFlexibleCardConte2 === void 0 ? void 0 : _useFlexibleCardConte2.ui :
  // eslint-disable-next-line react-hooks/rules-of-hooks
  useContext(FlexibleUiOptionContext);
};